<template>
    <v-modal title="Add customer data to blacklist" @close="$emit('close')" :scroll="true">
        <div slot="content">
            <div class="grid-content">
                <div class="grid-item grid-item-full">
                    <div class="field">
                        <v-select
                            placeholder="Select type"
                            label="Select Blacklist Type"
                            :options="blacklistTypes"
                            v-model="blacklistItem.type"
                            @input="onTypeChange"/>
                    </div>
                </div>
            </div>
            <template v-if="blacklistItem.type !== null" class="grid-content">
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <template v-if="blacklistItem.type === 'country'">
                            <v-select
                                label="Country"
                                class="field"
                                auto-focus
                                :options="countryList"
                                ref="countryList"
                                placeholder="Select Country"
                                v-model="blacklistItem.value"
                                :validate="$v.blacklistItem.value"
                            />
                        </template>
                        <r-input
                            v-else
                            :label="blacklistLabel"
                            class="field"
                            v-model="blacklistItem.value"
                            auto-focus
                            :validate="$v.blacklistItem.value"
                        />
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input
                            label="TTL (Time to Live)"
                            class="field"
                            help-text="E.g. 30"
                            right-label="Seconds"
                            v-model="blacklistItem.expirationTime"
                            :validate="$v.blacklistItem.expirationTime"
                        />
                    </div>
                </div>
            </template>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="save">Save</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {
        email, minValue, numeric, or, required,
    } from 'vuelidate/lib/validators';
    import {
        vIcon, vSelect,
    } from '@/components/form';
    import {mapState} from 'vuex';
    import BlacklistModel from '@/common/models/blacklist-model';
    import {COUNTRIES_LIST} from '@/data/countries';
    import BLACKLISTS from '@/data/blacklists';

    export default {
        name: 'lead-source-modal-modal',
        components: {
            vModal,
            vIcon,
            vSelect,
        },
        data() {
            return {
                countryList: COUNTRIES_LIST,
                blacklistItem: new BlacklistModel({type: this.type}),
                blacklistTypes: BLACKLISTS,
            };
        },
        computed: {
            ...mapState('customers', ['customer']),
            blacklistValues() {
                return {
                    bin: this.customer.defaultPaymentInstrument && this.customer.defaultPaymentInstrument.bin,
                    country: this.customer.primaryAddress && this.customer.primaryAddress.country,
                    address: this.customer.primaryAddress && this.customer.primaryAddress.address,
                    fingerprint: this.customer.panFingerprint,
                    email: this.customer.email,
                    'email-domain': this.customerEmailDomain,
                    'ip-address': this.customer.ipAddress,
                    'customer-id': this.customer.id,
                };
            },
            blacklistLabel() {
                const type = this.blacklistTypes.find(item => item.value === this.blacklistItem.type);
                if (type) {
                    return type.label;
                }
                return 'Value';
            },
            customerEmailDomain() {
                return this.customer.email && this.customer.email.replace(/.*@/, '');
            },
        },
        validations() {
            const validation = {
                blacklistItem: {
                    type: {required},
                    value: {required},
                    expirationTime: {
                        numeric,
                        minValueOrZero: or(v => Number(v) === 0, minValue(30)),
                    },
                },
            };
            if (this.blacklistItem.type === 'email') {
                validation.blacklistItem.value = {required, email};
            }
            if (this.blacklistItem.type === 'email-domain') {
                const pattern = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
                validation.blacklistItem.value = {required, emailDomain: v => pattern.test(v)};
            }
            if (this.blacklistItem.type === 'address') {
                const pattern = /^\d+\/[^\s-][\w\s-]*$/;
                validation.blacklistItem.value = {required, address: v => pattern.test(v)};
            }
            return validation;
        },
        methods: {
            onTypeChange(value) {
                this.blacklistItem.value = this.blacklistValues[value] || null;
            },
            async save() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.$emit('update', this.blacklistItem);
                    this.$emit('close');
                }
            },
        },
    };
</script>
